/** Portal admin role helpers (shared by route guards and layout). */

export const USER_ROLES = {
  CUSTOMER: 'customer',
  ADMIN: 'admin',
  BRANCHADMIN: 'branchadmin',
  BRANDADMIN: 'brandadmin',
  SUPERADMIN: 'superadmin'
};

/** Roles allowed to use the admin portal. `admin` is a legacy branch-admin alias. */
export const PORTAL_ROLES = [
  USER_ROLES.SUPERADMIN,
  USER_ROLES.BRANDADMIN,
  USER_ROLES.BRANCHADMIN,
  USER_ROLES.ADMIN
];

export const isPortalAdmin = (role) => PORTAL_ROLES.includes(role);

export const isSuperAdmin = (role) => role === USER_ROLES.SUPERADMIN;

export const isBrandAdmin = (role) => role === USER_ROLES.BRANDADMIN;

export const isBranchAdmin = (role) =>
  role === USER_ROLES.BRANCHADMIN || role === USER_ROLES.ADMIN;

export const roleLabel = (role) => {
  if (role === USER_ROLES.SUPERADMIN) return 'Super Admin';
  if (role === USER_ROLES.BRANDADMIN) return 'Brand Admin';
  if (isBranchAdmin(role)) return 'Branch Admin';
  return role || 'Admin';
};
